module.exports = __webpack_public_path__ + "static/turtle-creek-house39-d1efb6e97d3953948c0cfb6a9e2031d9.jpg";